module.exports = __webpack_public_path__ + "static/banner3-c12a0de7c7bd32c74253e3dd71e25e99.jpg";